import { Dispatch } from 'react';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { AgentQualificationDetailReport } from '../types/opm-ad-types';

const opmAdEndpoint = 'opm-ad';

export const fetchAdAgentQualificationDetailReport = async (
  agentCode: string,
  dispatch?: Dispatch<any>,
): Promise<AgentQualificationDetailReport> => {
  return apiClient
    .get(`${ADMIN_URL}/${opmAdEndpoint}/agent/${agentCode}/qualification-detail-report`)
    .then((response) => response.data.data as AgentQualificationDetailReport)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
